import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const TextInput = /*@__PURE__*/ proxyCustomElement(class TextInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.inputHandler(name, target.value);
            this.formControlInput.emit({ name, value: target.value });
        };
        this.updateInput = (newValue) => {
            const inputElement = this.el.querySelector('input');
            if (inputElement) {
                inputElement.value = newValue || '';
            }
        };
        this.name = undefined;
        this.label = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.maxLength = undefined;
        this.keyDownHandler = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    render() {
        return (h(Host, { key: '242da84a35d52f4d44bcaaa1ec016487ffb5936e', exportparts: "label,input,input-invalid" }, h("div", { key: 'a581089ec206ac71f586c837f53aec54e394776a', class: "form-group d-flex flex-column" }, h("div", { key: '88e11b4a8d79e72f63f80415b5dad74d8a47fa5b', class: "d-flex align-items-start gap-2" }, h("label", { key: 'd37f5e37ab6e46c43196638301e46410d70f753c', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '2702eabd98b632487a418facb33855bdb19b5167', helpText: this.helpText })), h("input", { key: 'e70affeeed2f0d0975a827e9d691a05c7732854f', id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, onKeyDown: this.keyDownHandler, onPaste: this.keyDownHandler, maxLength: this.maxLength, part: `input ${this.errorText ? "input-invalid " : ""}${this.disabled ? " input-disabled" : ""}`, class: this.errorText ? "form-control is-invalid" : "form-control", type: "text", disabled: this.disabled }), h("form-control-error-text", { key: 'f1ba545bec21198a4e78e4989bf5703f17052642', errorText: this.errorText, name: this.name }))));
    }
    get el() { return this; }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-text", {
        "name": [8],
        "label": [1],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "maxLength": [2, "max-length"],
        "keyDownHandler": [16],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-text", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-text":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, TextInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TextInput as T, defineCustomElement as d };
